/* global $ */

import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
barba.use(barbaPrefetch);



class Router {
  constructor(mainApp) {
    this.mainApp            = mainApp;
    this.currentNamespace   = '';
    this.pageApp = undefined;


    barba.init({
      timeout: 6000,
      debug: false,
      transitions: [{
        name: 'default',
        beforeOnce : () => {
        },
        once : (data) => {
          this.currentNamespace = data['next']['namespace'];
        },
        afterOnce : (data) => {
          this.checkPageApp(data);
          this.mainApp.initPageApp(this.currentNamespace);
          /*
          this.checkPageApp(data);
          setTimeout(() => {
            this.mainApp.checkPageApp();
          }, 50);
          */
        },
        before: async () => {
          this.mainApp.destroy();
          let waitDuration = 0;
          await new Promise((resolve) => {
            return setTimeout(resolve, waitDuration);
          });
        },
        leave : () => {
          // console.log('leave');
        },
        enter : (data) => {
          // console.log('enter');
          window.scrollTo(0, 0);
          this.checkPageApp(data);

          setTimeout(() => {
            this.mainApp.initPageApp(this.currentNamespace);
          }, 50);

          this.currentNamespace = data['next']['namespace'];
        }
      }]
    });


    $('body').on('click', '.js-router-force' , (e) => {
      e.preventDefault();
      barba.force('//' + window.host_uri + $(e.currentTarget).attr('href'));
      return false;
    });

    window.appRouter = barba;
  }

  go(target) {
    barba.go(target);
  }

  checkPageApp(data) {
    this.currentNamespace = data.next.namespace;

    if(data['next']['url']['path'].indexOf('/en') != -1) {
      $('.js-change-lang--en').addClass('-disabled');
    } else {
      $('.js-change-lang--jp').addClass('-disabled');
    }

    // console.log('Router.checkPageApp', nextNamespace);
    /*
    if(nextNamespace == 'sample') {
      console.log('check grid');
      if($('.DummyGrid').css('display') == 'none') {
        $('.DummyGrid').css('display', 'flex');
      }
    } else {
      if($('.DummyGrid').css('display') == 'flex') {
        $('.DummyGrid').css('display', 'none');
      }
    }
    */
  }



}

export default Router;
